import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useHttp from "../../../../hooks/use-http";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";
import { AutoComplete } from "antd";
import * as XLSX from "xlsx";
import { fmanReportRedirectBasedOnUseCase } from "../../../../utils/reportNavigationHelper"

const CropCutReport = () => {
  const frmRef = useRef({});
  const navigate = useNavigate();
  const redirectBasedOnUseCase = () => {
    const useCase = localStorage.getItem("useCase");

    switch (useCase) {
      case "Procurement":
        navigate("/fmnmis");
        break;

      case "Seed Production":
        navigate("/SeedMIS");
        break;

      case "Agri Promoter":
        navigate("/agrimis");
        break;

      case "Research Program":
        navigate("/researchProgramMIS");
        break;

      default:
        navigate("/fmnmis");
        break;
    }
  };

  const handleButtonClick = () => {

    const useCase = localStorage.getItem("useCase");
    fmanReportRedirectBasedOnUseCase(navigate, useCase);
  };

  const [loading, setLoading] = useState(false);

  const [employeeId, setEmployeeId] = useState(0);
  const [employeeData, setEmployeeData] = useState([]);
  const [regionData, setRegionData] = useState([]);
  const [employeeAllData, setEmployeeAllData] = useState([]);
  const [regionId, setRegionId] = useState();
  const [stateName, setStateName] = useState();
  const [stateData, setStatedata] = useState([]);

  const [farmerNumber, setFarmerNumber] = useState("");

  const [farmerData, setFarmerData] = useState();

  const [showDateFilter, setShowDateFilter] = useState(false);

  const handleDateFilterChange = (e) => {
    setShowDateFilter(e.target.value === "Yes");
  };

  // const [data, setData] = useState([]);

  // const itemsPerPage = localStorage.getItem("pageSize") || 10;
  // const [currentPage, setCurrentPage] = useState(1);
  // const indexOfLastItem = currentPage * itemsPerPage;
  // const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  // const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  // const paginate = (pageNumber) => {
  //   setCurrentPage(pageNumber);
  // };

  const [data, setData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  const itemsPerPage = localStorage.getItem("pageSize") || 10;

  const [currentPage, setCurrentPage] = useState(1);

  const currentItems = data || [];

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleFDateChange = (e) => {
    //console.log("handleFDateChange", e.target.value);
    setSelectedFromDate(e.target.value);
    setData([]);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
    setData([]);
  };

  // var date =date.setDate(date.getDate() + 10);

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 30);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);

  //console.log("toDate", toDate);

  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getCropCutData } = useHttp();

  const fillCropCutData = async (
    employeeId,
    regionId,
    farmerNo,
    getType = ""
  ) => {
    var urlfilter = "";

    if (showDateFilter) {
      urlfilter = urlfilter + `&fromDate=${selectedFromDate}`;
      urlfilter = urlfilter + `&toDate=${selectedToDate}`;
    }

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }

    if (regionId > 0) {
      urlfilter = urlfilter + `&regionId=${regionId}`;
    }
    if (farmerNo != "") {
      urlfilter = urlfilter + `&farmerNo=${farmerNo}`;
    }

    if (getType != "") {
      urlfilter = urlfilter + `&getType=${getType}`;
    }

    if (
      stateName &&
      typeof stateName === "string" &&
      stateName.trim().length > 0
    ) {
      const sanitizedState = stateName.trim().replace(/[^a-zA-Z0-9_\- ]/g, "");
      urlfilter = urlfilter + `&stateName=${sanitizedState}`;
    }

    var url = `/api/farmerCropCutDetailReport/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter} `;

    getCropCutData(
      {
        url: url,
      },
      (data) => {
        console.log("reportdata", data);
        if (getType == "Excel") {
          console.log("reportdata", data);
          // const handleDownload = async () => {
          //   const blob = await data.blob();
          //   const url = window.URL.createObjectURL(blob);
          //   const link = document.createElement('a');
          //   link.href = url;
          //   link.download = 'downloaded-file.csv'; // Set the file name here
          //   link.click();
          // }
        } else {
          console.log("reportdata", data);
          // setData(data);
          setData(data.results || []);
          setTotalCount(data.count || 0);
        }
      }
    );
  };

  const excelDownload = async (
    employeeId,
    regionId,
    farmerNo,
    getType = "Excel"
  ) => {
    setLoading(true);
    var urlfilter = "";

    if (showDateFilter) {
      urlfilter = urlfilter + `&fromDate=${selectedFromDate}`;
      urlfilter = urlfilter + `&toDate=${selectedToDate}`;
    }

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }

    if (regionId > 0) {
      urlfilter = urlfilter + `&regionId=${regionId}`;
    }
    if (farmerNo != "") {
      urlfilter = urlfilter + `&farmerNo=${farmerNo}`;
    }

    // if (getType != "") {
    //   urlfilter = urlfilter + `&getType=${getType}`;
    // }

    if (
      stateName &&
      typeof stateName === "string" &&
      stateName.trim().length > 0
    ) {
      const sanitizedState = stateName.trim().replace(/[^a-zA-Z0-9_\- ]/g, "");
      urlfilter = urlfilter + `&stateName=${sanitizedState}`;
    }

    // var url = `${
    //   process.env.REACT_APP_BASE_URL
    // }/api/farmerCropCutDetailReport/?orgId=${localStorage.getItem(
    //   "orgId"
    // )}&empId=${localStorage.getItem("empId")}${urlfilter}`;

    var url = `${process.env.REACT_APP_BASE_URL
      }/api/farmerCropCutDetailReport/?orgId=${localStorage.getItem(
        "orgId"
      )}&empId=${localStorage.getItem("empId")}${urlfilter}&getType=Excel`;

    try {
      const response = await fetch(url, {
        method: "GET",
        "Content-Type":
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        authorization: `Bearear ${localStorage.getItem("token")}`,
      });

      if (!response.ok) {
        console.error(`Error ${response.status}: ${response.statusText}`);
        setLoading(false);
      }

      const blob = await response.blob();

      const downloadUrl = window.URL.createObjectURL(blob);

      console.log(downloadUrl);

      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = "cropCutReport.xlsx";
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(downloadUrl);
      document.body.removeChild(link);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error downloading file:", error);
    }
  };

  useEffect(() => {
    fillCropCutData(0, 0, "");
  }, [getCropCutData]);

  const handleExportExcel = () => {
    const headers = [
      "Date",
      "Farmer Code",
      "Farmer Name",
      "Farmer Type",
      "Created User",
      "State",
      "LGA",
      "Village",
      "Mobile Number",
      "Crop-Cut-Weight-A",
      "Crop-Cut-Weight-B",
      "Crop-Cut-Weight-C",
      "Crop-Cut-Weight-D",
      "Actual Field Size Before Harvest (Ha)",
      "Total Harvested Bags",
      "Created Date", // Created Date column
      "Crop Cut Images", // Image URL column
    ];

    const worksheet = XLSX.utils.aoa_to_sheet([headers]);

    // Function to get column widths based on data
    const getColumnWidths = (dataArray, headersArray) => {
      return headersArray.map((header, colIndex) => {
        const maxTextLength = Math.max(
          header.length,
          ...dataArray.map(
            (item) => String(Object.values(item)[colIndex] || "").length
          )
        );
        return { wch: maxTextLength + 5 }; // Extra width for links
      });
    };

    // Function to get row heights for Excel
    const getRowHeights = (rowCount) => {
      return Array.from({ length: rowCount + 1 }, (_, index) => ({
        hpt: index === 0 ? 20 : 18, // Header row is taller
      }));
    };

    let currentRowIndex = 2; // Start from row 2 (after headers)

    const imageColumn = "Q";
    var fpath = "/api/filedownload/";
    data.forEach((item) => {


      const imageUrls = item.attachments?.length
        ? item.attachments
          .map((attachment) => {

            if (attachment.urlAttachments) {
              if (attachment.urlAttachments.startsWith("http")) {
                return attachment.urlAttachments;
              } else {

                return `${process.env.REACT_APP_BASE_URL}${fpath}${attachment.urlAttachments}`;
                // return `${process.env.REACT_APP_FILE_URL}${attachment.urlAttachments}`;
              }
            }
            return null;
          })
          .filter((url) => url !== null)
        : [];

      const rowValues = [
        item.cropCutDate,
        item.farmerNo,
        item.farmerName,
        item.farmerStatus,
        item.employeeName,
        item.state,
        item.lga,
        item.villageName,
        item.mobile,
        item.cropCutWeightA,
        item.cropCutWeightB,
        item.cropCutWeightC,
        item.cropCutWeightD,
        item.actualFieldSizeBeforeHarvest,
        item.totalHarvestedBags,
        item.createdDate,
      ];

      XLSX.utils.sheet_add_aoa(worksheet, [rowValues], {
        origin: `A${currentRowIndex}`,
      });

      if (imageUrls.length > 0) {
        imageUrls.forEach((url, i) => {
          worksheet[`${imageColumn}${currentRowIndex}`] = {
            t: "s",
            v: url,
            l: { Target: url, Tooltip: `Click to view/download image ${i + 1}` },
          };
          currentRowIndex++;
        });
      } else {
        worksheet[`${imageColumn}${currentRowIndex}`] = {
          t: "s",
          v: "NA",
        };
        currentRowIndex++;
      }
    });

    worksheet["!cols"] = getColumnWidths(data, headers);
    worksheet["!rows"] = getRowHeights(currentRowIndex);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "CropCutReport");

    XLSX.writeFile(workbook, "CropCutReport.xlsx", { WTF: true });
  };


  const { sendRequest: getEmp } = useHttp();

  const EmployeeDetail = (state) => {
    var urlfilter = "";

    if (state && typeof state === "string" && state.trim().length > 0) {
      const sanitizedState = state.trim().replace(/[^a-zA-Z0-9_\- ]/g, "");
      urlfilter = urlfilter + `&stateName=${sanitizedState}`;
    }
    getEmp(
      {
        url: `/api/employeeListForProcReort/?useCase=Procurement&empId=${localStorage.getItem(
          "empId"
        )}&orgId=${localStorage.getItem("orgId")}${urlfilter} `,
      },
      (data) => {
        console.log("emp", data);
        var emplist = data;

        setEmployeeData(emplist);
        setEmployeeAllData(emplist);
      }
    );
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, [getEmp]);

  const { sendRequest: getStateData } = useHttp();
  useEffect(() => {
    getStateData(
      {
        url: `/api/stateLocation/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        console.log("state", data);

        setStatedata(data);
      }
    );
  }, [getStateData]);

  const { sendRequest: getRegion } = useHttp();
  useEffect(() => {
    getRegion(
      {
        url: `/api/procurementRegionList/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        //console.log("region", data);

        setRegionData(data.data);
      }
    );
  }, [getRegion]);

  const { sendRequest: getFarmerNumber } = useHttp();
  useEffect(() => {
    getFarmerNumber(
      {
        url: `/api/farmerNumberList/?orgId=${localStorage.getItem(
          "orgId"
        )}&empId=${localStorage.getItem(
          "empId"
        )}&fieldExecutiveId=${employeeId}`,
      },
      (data) => {
        // console.log("farmerNumberList", data);

        setFarmerData(data);
      }
    );
  }, [employeeId]);

  const handleSearch = (value) => {
    setFarmerNumber(value);
    setData([]);
  };

  // const options = farmerData&&farmerData.map(item => ({ value: item.identificationNo }));

  const filteredOptions =
    farmerData &&
    farmerData
      .filter((item) => item.farmerNo.includes(farmerNumber))
      .map((item) => ({ value: item.farmerNo }));

  //console.log(filteredOptions);

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-md-8 mt-3">
            <label className="card-title">Crop Cut Report</label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <br />
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>State</label>
                  <select
                    id="stateName"
                    className="form-control"
                    ref={(el) => (frmRef.current["stateName"] = el)}
                    value={stateName}
                    onChange={(e) => {
                      var sName = "";

                      if (e.target.value != "--Select--") {
                        sName = e.target.value;
                        console.log("sName", sName);
                      }
                      setStateName(sName);
                      EmployeeDetail(sName);
                      setData([]);
                      setEmployeeId(0);
                    }}
                  >
                    <option value="">Select</option>
                    {stateData &&
                      stateData.map((x) => (
                        <option
                          key={x.stateName}
                          user-id={x.stateName}
                          value={x.stateName}
                        >
                          {x.stateName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor={"executive_officer"}>
                    {"Procurement Officer"}
                  </label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      var userid = 0;
                      if (e.target.value != "--Select--")
                        userid = e.target.value;

                      setEmployeeId(userid);
                      setData([]);
                    }}
                  >
                    <option value="0">Select</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option
                          key={x.userId}
                          user-id={x.userId}
                          value={x.userId}
                        >
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <label htmlFor="farmer_number">Farmer Number</label>
                <AutoComplete
                  className="form-control"
                  style={{ height: "30px" }}
                  value={farmerNumber}
                  options={filteredOptions}
                  placeholder="Farmer Number"
                  onChange={handleSearch}
                />
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"date_filter"}>{"Apply Date Filter"}</label>
                  <select
                    id="date_filter"
                    className="form-control"
                    ref={(el) => (frmRef.current["date_filter"] = el)}
                    onChange={handleDateFilterChange}
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>
              {showDateFilter && (
                <>
                  <div className="col-md-3">
                    <div className="form-group">
                      {" "}
                      <label htmlFor={"from_date"}>{"From Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedFromDate}
                        onChange={handleFDateChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label htmlFor={"to_date"}>{"To Date"}</label>

                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedToDate}
                        onChange={handleTDateChange}
                      />
                    </div>
                  </div>
                </>
              )}
              <div className="col-md-3  text-right">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      fillCropCutData(employeeId, regionId, farmerNumber);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                // onClick={handleExportExcel}
                onClick={() =>
                  excelDownload(
                    employeeId,
                    regionId,
                    farmerNumber,
                    "Excel"
                  )
                }
              >
                <i className="fas fa-file-excel"></i>
              </button>

              {/* <button
                type="button"
                className="btn btn-sm btn-warning mx-3"
                onClick={(e) => {
                  excelDownload(employeeId, regionId, farmerNumber, "Excel");
                }}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <i className="fas fa-spinner fa-spin"></i>
                  </>
                ) : (
                  <>
                    <i className="fas fa-file-image"></i>
                  </>
                )}
              </button> */}
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered table-responsive text-center table-sm">
                      <thead>
                        <tr className="table-header">
                          <th>Sr.No</th>
                          <th>Date</th>
                          <th>Farmer Code</th>
                          <th>Farmer Name</th>
                          <th>Farmer Type</th>
                          <th>Created User</th>
                          <th>State</th>
                          <th>LGA</th>
                          <th>Village</th>
                          <th>Mobile Number</th>
                          <th>Crop-Cut-Weight-A</th>
                          <th>Crop-Cut-Weight-B</th>
                          <th>Crop-Cut-Weight-C</th>
                          <th>Crop-Cut-Weight-D</th>
                          <th>Actual field Size before Harvest(Ha)</th>
                          <th>Total Harvested Bags</th>
                          <th>Created Date</th>
                          <th>Crop Cut Image</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i} className="tablerowview">
                                {/* <td>{i + 1}</td> */}
                                <td>{(currentPage - 1) * itemsPerPage + i + 1}</td>
                                <td>{itm.cropCutDate}</td>
                                <td>{itm.farmerNo}</td>
                                <td>{itm.farmerName}</td>
                                <td>{itm.farmerStatus}</td>
                                <td>{itm.employeeName}</td>
                                <td>{itm.state}</td>
                                <td>{itm.lga}</td>
                                <td>{itm.villageName}</td>
                                <td>{itm.mobile}</td>
                                <td>{itm.cropCutWeightA}</td>
                                <td>{itm.cropCutWeightB}</td>
                                <td>{itm.cropCutWeightC}</td>
                                <td>{itm.cropCutWeightD}</td>
                                <td>{itm.actualFieldSizeBeforeHarvest}</td>
                                <td>{itm.totalHarvestedBags}</td>
                                <td>{itm.createdDate}</td>
                                <td>
                                  {itm.attachments &&
                                    itm.attachments.length > 0 ? (
                                    <div
                                      style={{
                                        display: "grid",
                                        gridTemplateColumns: "repeat(2, auto)",
                                        gap: "5px",
                                      }}
                                    >
                                      {itm.attachments &&
                                        itm.attachments.map(
                                          (attachment, index) => {
                                            // Check if `urlAttachments` exists and construct the image URL
                                            const imageUrl =
                                              attachment.urlAttachments
                                                ? attachment.urlAttachments.startsWith(
                                                  "http"
                                                )
                                                  ? attachment.urlAttachments
                                                  : `${process.env.REACT_APP_FILE_URL}${attachment.urlAttachments}`
                                                : null;

                                            return (
                                              imageUrl && (
                                                <img
                                                  key={index}
                                                  src={imageUrl}
                                                  alt="Crop Cut Image"
                                                  style={{
                                                    width: "50px",
                                                    height: "auto",
                                                    margin: "2px",
                                                  }}
                                                />
                                              )
                                            );
                                          }
                                        )}
                                    </div>
                                  ) : (
                                    "NA"
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      // totalItems={data.length}
                      totalItems={totalCount}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>


    </>
  );
};

export default CropCutReport;
